var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-24", attrs: { id: "problem-behavior" } },
    [
      _c("div", { staticClass: "flex justify-center py-10" }, [
        _c(
          "div",
          {
            staticClass:
              "relative py-10 overflow-hidden border w-180 h-min bg-pure-white border-slate-400 rounded-3xl"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between gap-10 pb-5 border-b bg-pure-white border-grey-200",
                attrs: { id: "problem-behavior-header" }
              },
              [
                _c("div", { staticClass: "flex flex-col gap-1 px-10" }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: "Problem Behavior Codes" }
                      }),
                      _vm._v(" "),
                      _c("BlBubbleCount", {
                        attrs: {
                          count:
                            (_vm.problemBehaviors &&
                              _vm.problemBehaviors.length) ||
                            0
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-grey-400" },
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "These are the problem behavior codes for Skill-Based Treatment used in this center. Any changes made here will be applied to all existing targets."
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.pageLoading
              ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                  _c("div", { staticClass: "blum-loader" })
                ])
              : _c(
                  "div",
                  {},
                  [
                    !_vm.currentUser.role.includes("admin")
                      ? _c("div", { staticClass: "w-full px-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center gap-2 px-4 py-2 rounded-b bg-info-100"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid flex-shrink-0 w-10 h-10 place-items-center",
                                  style: {
                                    background: "#E4F1FA",
                                    borderRadius: "0.25rem"
                                  }
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-6 h-6",
                                    attrs: { icon: "toast-info" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody1", {
                                staticClass: "text-info",
                                attrs: {
                                  text:
                                    "Please note that the ability to add or edit in the Repository is restricted to users with the Admin role."
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        staticClass: "px-10 py-6 ",
                        class: _vm.currentUser.role.includes("admin")
                          ? "space-y-4"
                          : "",
                        attrs: { handle: ".handle" },
                        on: {
                          update: function($event) {
                            $event.preventDefault()
                            return _vm.onMovePosition($event)
                          }
                        }
                      },
                      _vm._l(_vm.problemBehaviors, function(problemBehavior) {
                        return _c(
                          "div",
                          {
                            key: problemBehavior.id,
                            staticClass: "flex items-start gap-4",
                            attrs: { id: problemBehavior.id }
                          },
                          [
                            _vm.currentUser.role.includes("admin")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center flex-shrink-0 w-2 mt-4 text-sm cursor-move handle text-grey-400"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "flex-shrink-0 w-4",
                                      attrs: { icon: "drag" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("ProblemBehaviorItem", {
                              attrs: {
                                problemBehavior: problemBehavior,
                                readOnly: !_vm.currentUser.role.includes(
                                  "admin"
                                ),
                                disabledDelete: problemBehavior.is_used,
                                tooltipDelete: problemBehavior.is_used,
                                tooltipPosition: "left"
                              },
                              on: { update: _vm.onUpdate, delete: _vm.onRemove }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "px-10" }, [
                      _vm.currentUser.role.includes("admin")
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "flex items-center gap-2 mt-5 outline-none",
                              staticStyle: { width: "fit-content" },
                              on: { click: _vm.onCreate }
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "font-bold text-primary" },
                                [_vm._v("Add code")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de9829c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de9829c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/sbt/ProblemBehavior.vue
// module id = null
// module chunks = 